import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { formatMask } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { memberApi as API } from '../Apis';

import { MemberTypes } from '../Types';
import {
  IMemberAddress,
  MemberDocumentType,
  MemberEletronicAddressType,
  MemberPhoneType,
} from '../Types/CommonTypes';

export const GetMemberDocs: IDocs = {
  title: 'GetMember',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.getMember',
};

const prepareCall = () => API.call.get();

const handleSucessFinalResponseFunction = (data: any) => {
  const cellPhone = data?.member?.phoneList?.find(
    (e: MemberPhoneType) => e.type === 'CELLULAR',
  );
  const dataResponse: MemberTypes.MemberData = {
    memberNumber: data?.member?.memberNumber,
    firstName: data?.member?.firstName,
    lastName: data?.member?.lastName,
    birthDay: data?.member?.birthDay,
    gender: data?.member?.gender,
    citizenship: data?.member?.citizenship,
    memberType: data?.member?.memberType,
    availableMiles: data?.member?.availableMiles,
    milesToExpire: data?.member?.milesToExpire,
    milesNextExpirationDate: data?.member?.milesNextExpirationDate,
    owner: data?.member?.owner,
    category: data?.member?.category,
    status: data?.member?.status,
    memberSince: data?.member?.memberSince,
    address:
      data?.member?.addressList?.length === 1
        ? data?.member?.addressList[0]
        : data?.member?.addressList.find((e: IMemberAddress) => e.preferential),
    document:
      data?.member?.documentList?.length === 1
        ? data?.member?.documentList[0]
        : data?.member?.documentList.find(
            (e: MemberDocumentType) => e.type === 'CPF',
          ),
    email: data?.member?.electronicAddressList.find(
      (e: MemberEletronicAddressType) => e.preferential,
    )?.address,
    isClubMember: data?.member?.isClubMember,
    isMgmMember: data?.member?.isMgmMember,
    lastLogin: data?.member?.lastLogin,
    allowPromoEmail: data?.member?.allowPromoEmail,
    allowMail: data?.member?.allowMail,
    allowSMS: data?.member?.allowSMS,
    allowCall: data?.member?.allowCall,
    language: data?.member?.language,
    isFamilyAccount: data?.member?.isFamilyAccount,
    programName: data?.member?.programName,
    iva: data?.member?.iva,
    socialIdNumber: data?.member?.socialIdNumber,
    socialIdProvider: data?.member?.socialIdProvider,
    lastUpdateDate: data?.member?.lastUpdateDate,
    statusCobranded: data?.member?.statusCobranded,
    cellPhone: cellPhone
      ? {
          DDI: cellPhone.internationalCode,
          DDD: cellPhone.areaCode,
          number: cellPhone.number,
          formatted: {
            display: `+${cellPhone.internationalCode} (${
              cellPhone.areaCode
            }) ${formatMask(cellPhone.number, '#-0000', true)}`,
          },
        }
      : undefined,
  };

  Bundle.clearValue('smilesToken');
  return dataResponse;
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesCheckAccount = !infos?.errorService;
  const smilesErrorService = infos?.errorService || !smilesCheckAccount;

  return { smilesCheckAccount, smilesErrorService };
};

export const GetMemberMachine = GenericMachine(
  prepareCall,
  {
    docs: GetMemberDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
    handleErrorFlowFinalResponseFunction,
  },
);
